var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);
